import Axios from '@/assets/js/AxiosPlugin'

// 个人消费记录
export const getSpendList = params => { return Axios.post('/api/Home/User/getSpendList', params) }

// 个人充值记录
export const getRechargeList = params => { return Axios.post('/api/Home/User/getRechargeList', params) }



// WEBPACK FOOTER //
// ./src/views/mobile/BillList/apis/index.js